<template>
    <div class="d-flex justify-content-center fw-light">
        <i>{{ $t('All monetary figures shown below are in') }} <strong>{{ currencyLabel }}</strong> {{ $t('and are exclusive of tax.') }}</i>
    </div>
</template>
<script>
export default {
    name : 'FigureCurrencyNote',
    props : ['currency'],
    computed : {
        currencyLabel(){
            const currencyName = this.FormatCurrencyName(this.currency?.name || this.currency?.code || this.currency?.shortName || this.currency?.sign || '')
            const localizedCurrencyName = this.$te(currencyName) ? this.$t(currencyName) : currencyName
            const currencySign = this.currency?.sign || ''

            if(localizedCurrencyName && currencySign){
                return `${localizedCurrencyName} (${currencySign})`
            }

            return localizedCurrencyName || currencySign || '-'
        }
    },
    methods : {
        FormatCurrencyName(value){
            return String(value || '')
                .replace(/\s+/g, ' ')
                .trim()
                .replace(/[A-Za-z]+/g, (word)=>{
                    if(word.length <= 3 && word === word.toUpperCase()){
                        return word
                    }

                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                })
        }
    }
}
</script>
